import L from 'leaflet';

export let keys = {
    ENTER: 13,
};

export const basemapMaxZoom = 21;

export let iconToIntl = {
    polygon: 'polygon',
    polyline: 'polyline',
    marker: 'icon',
};

export function convertScreenToLeafletPt(screenPos, map) {
    let pt = L.point(screenPos[0], screenPos[1]);
    return map.layerPointToLatLng(pt);
}

export function mobilecheck(iconLength = 0) {
    const width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    const iconWidth = 77.5625;
    return width < Math.max(768, iconLength * iconWidth);
}

export function generateResponseID() {
    let msSince2012 = new Date().getTime() - 1325376000000;
    return msSince2012 + "-" + Math.floor(Math.random() * 10000);
}

export function postData(url, data, response) {
    fetch(url, {
        method: 'POST',
        redirect: 'manual',
        headers: {
            'Accept': 'text/plain',
            'Content-Type': 'text/plain',
        },
        body: data
    }).then(response).catch(error => console.log("Fetch error.", error));
}

export function formatElementsforExport(elements) {
    const POINT = 'Point';
    const MULTILINESTRING = 'MultiLineString';
    const POLYGON = 'Polygon';

    const featureType = {
        "marker": POINT,
        "polyline": MULTILINESTRING,
        "polygon": POLYGON
    };

    function getCoordinates(elemPos, type) {
        if (type === POINT) {
            return [elemPos.lng, elemPos.lat];
        } else if (type === MULTILINESTRING || type === POLYGON) {//append extra square brackets
            return [elemPos.map(latlong => {
                return [latlong.lng, latlong.lat]
            })];
        } else {
            console.log('WARNING! Unrecognized type ', type, ' elemPos, ' + elemPos);
        }
    }

    let elementExportObj = [];
    elements.forEach(function (element) {
        let elementPost = {};

        // Info from ElementModel
        elementPost.uuid = element.uuid;
        elementPost.comment = element.text;
        elementPost.reaction = element.reaction;
        elementPost.starRating = element.starRating;

        // Info from IconModel
        elementPost.type = element.type;
        elementPost.text = element.icon.text;
        elementPost.id = element.icon.id;

        elementPost.geom = {
            coordinates: getCoordinates(element.position, featureType[element.type]),
            type: featureType[element.type]
        };
        elementExportObj.push(elementPost);
    });
    return elementExportObj;
}

export function getIconSrc(image) {
    if (image.indexOf('://') > -1) {
        return image;
    }
    return './icons/' + image;
}

export function getLogoSrc(image) {
    if (image.indexOf('://') > -1) {
        return image;
    }
    return './imgs/' + image;
}

export function returnPendingLeafletIcon(icon, mouseAttached) {
    let getIconImgElement = (icon) => {
        return `
            <img class="wrapper" aria-hidden="true" src="./imgs/pin-container.png" />
            <img class="icon" alt="${icon.text} Marker" style="background-color: ${icon.color}" src="${getIconSrc(icon.image)}">
        `;
    };

    return new L.divIcon({
        className: mouseAttached ? 'mouse-attached' : 'pending-icon',
        html: getIconImgElement(icon),
        iconSize: [48, 70],
        iconAnchor: [24, 70],
    });
}



// WEBPACK FOOTER //
// ./src/utils/Utils.js